import React, { useEffect, useContext } from "react";
import "./LocalityFieldset.scss";
import Select from "react-select";
import FieldsetSelect from "../FieldsetSelect/FieldsetSelect";
import ScriptBoxCaller from "../ScriptBoxCaller/ScriptBoxCaller";
import SmallEditIcon from "../VectorIcons/SmallEditIcon";
import { LocalityContext } from "../../context/localityContext";
import useLocalities from "../../shared/utils/useLocalitiesByType";
import LocalityOption from "./LocalityOption/LocalityOption";

const LocalityFieldset = ({ localitiesSelected, setLocalitiesSelected }) => {
  const localityContext = useContext(LocalityContext);
  const { localities, fetchLocalities, refreshLocalities } = useLocalities();

  useEffect(() => {
    fetchLocalities();
  }, [fetchLocalities]);

  const handleLocalityTypeChange = (index, type) => {
    const newState = [...localitiesSelected];
    newState[index].type = type;
    newState[index].values = [];
    setLocalitiesSelected(newState);
  };

  const addLocalityField = () => {
    setLocalitiesSelected([
      ...localitiesSelected,
      { type: "Cidade", values: [] },
    ]);
  };

  const handleLocalityValuesChange = (index, selectedValue) => {
    const updated = [...localitiesSelected];
    updated[index].values = selectedValue ? [selectedValue] : [];
    setLocalitiesSelected(updated);
  };

  const canAddNewLocality = () => {
    return localitiesSelected.every((item) => item.values.length > 0);
  };

  const formatOrdinal = (n) => `${n}º`;

  const getOptionsForType = (type) => {
    if (!localities) return [];
    return localities.filter((loc) => loc.data.type === type);
  };

  React.useEffect(() => {
    if (localityContext.lastCreation) {
      refreshLocalities();
    }
  }, [localityContext.lastCreation, refreshLocalities]);

  React.useEffect(() => {
    if (localities && localityContext.lastCreation) {
      const found = localities.filter((locality) =>
        localityContext.lastCreation.includes(locality.data.id)
      );

      if (found) {
        setLocalitiesSelected((prevState) =>
          [...prevState].map((locality) => {
            const foundOnCreateds = found.find(
              (foundItem) =>
                foundItem.data.type === locality.type &&
                locality.values.length === 0
            );

            if (foundOnCreateds) {
              return {
                ...locality,
                values: [
                  {
                    ...foundOnCreateds.data,
                    label: foundOnCreateds.data.name,
                    value: foundOnCreateds.data.id,
                  },
                ],
              };
            }
            return locality;
          })
        );
      }
    }
  }, [localities, localityContext.lastCreation, setLocalitiesSelected]);

  return (
    <div className="formFieldColumn localityFieldset">
      {localitiesSelected.map((item, index) => (
        <div className={`formField `} key={index}>
          <div className="localityActionsHeader">
            {index === 0 && <span className="label">Localidade</span>}

            <div className="localityActions">
              {item.type && item.type !== "placeholder" && (
                <ScriptBoxCaller
                  callerText={"+ Cadastrar"}
                  event={() =>
                    localityContext.setToggleModalOpen({
                      type: "REGISTER",
                      index,
                    })
                  }
                />
              )}

              {item.values.length > 0 && (
                <ScriptBoxCaller
                  callerText={"Editar"}
                  callerIcon={<SmallEditIcon />}
                  _class="scriptBoxCaller editLocality"
                  event={() => {
                    localityContext.setToggleModalOpen({
                      type: "EDIT",
                      index,
                      selectedIdToEdit: item.values[0].value,
                    });
                  }}
                />
              )}
            </div>
          </div>

          <div className="localityContent">
            {localitiesSelected.length > 1 && (
              <div className="localityNumber">{formatOrdinal(index + 1)}</div>
            )}
            <div
              className={`contentOriginContainer ${
                localitiesSelected.length > 1 ? "" : ""
              }`}
              style={{ zIndex: 15 - index }}
            >
              <FieldsetSelect
                placeholder="Selecionar localidade"
                data={[
                  { id: "Bairro", name: "Bairro" },
                  { id: "Cidade", name: "Cidade" },
                  { id: "Estado", name: "Estado" },
                  { id: "Região", name: "Região" },
                  { id: "País", name: "País" },
                  { id: "Continente", name: "Continente" },
                ]}
                value={item.type}
                selected={item.type}
                handleChange={(ev) =>
                  handleLocalityTypeChange(index, ev.target.value)
                }
              />

              {item.type && item.type !== "placeholder" && (
                <Select
                  className="reactSelect"
                  classNamePrefix="reactSelect"
                  isClearable={true}
                  options={getOptionsForType(item.type)}
                  value={item.values}
                  onChange={(values) =>
                    handleLocalityValuesChange(index, values)
                  }
                  formatOptionLabel={(option, { context }) =>
                    context === "menu" ? option.label : option.label
                  }
                  noOptionsMessage={() => "Nenhum resultado encontrado"}
                  placeholder="Digite um local ou selecione da lista"
                  components={{
                    Option: LocalityOption,
                  }}
                  isDisabled={!item.type}
                />
              )}

              {(!item.type || item.type === "placeholder") && (
                <div className="select-placeholder" />
              )}
            </div>
          </div>
        </div>
      ))}

      <div
        className={`dashedBox ${
          !canAddNewLocality() ? "disabled" : ""
        } ga-locality-inclusion`}
        onClick={() => {
          if (canAddNewLocality()) {
            addLocalityField();
          }
        }}
      >
        <span className="ga-locality-inclusion">
          + Adicionar nova localidade
        </span>
      </div>
    </div>
  );
};

export default LocalityFieldset;
